import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl, InputLabel } from '@mui/material';

import BaseSelectWithCheckboxes from '../../../../../../shared/components/base-select-with-checkboxes/base-select-with-checkboxes';
import { useSelectWithCheckboxesOnChange } from '../../../../../../shared/components/base-select-with-checkboxes/hooks/use-select-with-checkboxes-on-change/use-select-with-checkboxes-on-change.hook';
import { WithOptionsModel } from '../../../../../../shared/components/with-options/models/with-options.model';
import { FirmwareFilters } from '../../../../models/firmware-filters.model';
import {
  filterFirmwaresByModel,
  resetModelFilter,
} from '../../../../store/slices/firmware.slice';
import { FirmwareFilterProps } from '../../types/firmware-filter-props.type';
import { withFirmwareFilterValues } from '../with-firmware-filters-values/with-firmware-filters-values';
import withModelsOptions from './components/with-models-options/with-models-options';

const ModelsDropdown: FunctionComponent<
  FirmwareFilterProps & WithOptionsModel
> = (
  props: PropsWithChildren<FirmwareFilterProps & WithOptionsModel>
): ReactElement => {
  const {
    values: { modelIds },
    setFieldValue,
    options,
    firmwareSelectFilters: { modelIds: selectedModelIds },
  } = props;

  const onChange = useSelectWithCheckboxesOnChange<FirmwareFilters>(
    'modelIds',
    setFieldValue,
    filterFirmwaresByModel,
    [{ fieldName: 'ecuIds', valueToReset: [] }],
    resetModelFilter
  );

  const selectedModelsMapped = options
    .filter(item => selectedModelIds.includes(item.id))
    .map(item => item.id);

  return (
    <FormControl
      classes={{
        root: 'form-control-main',
      }}
      key="firmware-models"
      variant="filled"
      disabled={!options.length}
    >
      <InputLabel id="multiple-checkbox-label-models">Vehicle Model</InputLabel>

      <BaseSelectWithCheckboxes
        id="modelIds"
        key="firmware-models"
        name="modelIds"
        onChange={onChange}
        selectOptions={options}
        clearMultiSelectFilterAction={filterFirmwaresByModel}
        value={selectedModelIds ? selectedModelsMapped : modelIds}
      />
    </FormControl>
  );
};

export default withFirmwareFilterValues(withModelsOptions(ModelsDropdown));
